import {
	Component,
	Input
}                        from '@angular/core';
import { ValueTypeEnum } from '@models/common.model';
import { IGroupConfig }  from '@shared/components/group/group.model';

@Component( {
	selector: 'app-form-elements-group-block[groupLabel]',
	templateUrl: './form-elements-group-block.component.html',
	styleUrls: [ './form-elements-group-block.component.scss' ]
} )
export class FormElementsGroupBlockComponent {

	private _defaultGroupConfig: IGroupConfig = {
		labelValue: null,
		labelValueType: ValueTypeEnum.VALUE,
		showToggleIcon: false,
		labelClass: 'fw-medium fs-l col-12 col-md-8 px-0 ps-md-2 offset-md-4 mb-2',
		labelSpareValue: '',
		collapsable: false
	};

	groupConfig: IGroupConfig;


	@Input() set groupLabel( groupLabel: string ) {
		this.groupConfig = {
			...this.groupConfig,
			labelValue: groupLabel
		};
	}

	@Input() set groupLabelClass( groupLabelClass: string ) {
		this.groupConfig = {
			...this.groupConfig,
			labelClass: groupLabelClass
		};
	}

	constructor() {
		this.groupConfig = { ...this._defaultGroupConfig };
	}
}
